<form [formGroup]="form" autocomplete="off">
  <div class="header-container">
    <p>* = required</p>
  </div>
  <div>
    <div>
      <div class="space-below">
        <emr-input type="text" [control]="form.controls.name" label="Name" placeholder="Enter name for order set"
          [required]="true" />
      </div>

      <button pButton pRipple type="button" label="Create Provider Order" icon="pi pi-plus"
        (click)="openProviderOrderDialog()"></button>

      <h3>Provider Orders</h3>
      <div class="table-container space-below">
        <p-table #dt [value]="providerOrdersForThisOrderSet" styleClass="p-datatable" [rowHover]="true" [rows]="5"
          [showCurrentPageReport]="true" [rowsPerPageOptions]="[5, 10, 25]" responsiveLayout="scroll" [paginator]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} orders" [filterDelay]="0">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="medName">
                <div class="flex justify-content-between align-items-center">
                  Medication
                  <p-sortIcon field="medName"></p-sortIcon>
                </div>
              </th>
              <th pSortableColumn="dosage">
                <div class="flex justify-content-between align-items-center">
                  Dosage
                  <p-sortIcon field="dosage"></p-sortIcon>
                </div>
              </th>
              <th pSortableColumn="route">
                <div class="flex justify-content-between align-items-center">
                  Route
                  <p-sortIcon field="route"></p-sortIcon>
                </div>
              </th>
              <th pSortableColumn="type">
                <div class="flex justify-content-between align-items-center">
                  Type
                  <p-sortIcon field="type"></p-sortIcon>
                </div>
              </th>
              <th pSortableColumn="administeredString">
                <div class="flex justify-content-between align-items-center">
                  Administered
                  <p-sortIcon field="administeredString"></p-sortIcon>
                </div>
              </th>
              <th>
                <div class="flex justify-content-between align-items-center">
                  <div class="actions-title-container">Actions</div>
                </div>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-order>
            <tr class="p-selectable-row">
              <td>
                {{ order.medName }}
              </td>
              <td>
                {{ order.dosage }}
              </td>
              <td>
                {{ order.route }}
              </td>
              <td>
                {{ order.type }}
              </td>
              <td>
                {{ order.administeredString }}
              </td>
              <td class="actions-container">
                <button pButton type="button" class="p-button-primary" icon="pi pi-eye" pTooltip="View provider order"
                  (click)="viewProviderOrder(order)"></button>
                <button pButton type="button" class="p-button-danger" icon="pi pi-trash"
                  pTooltip="Delete provider order" (click)="deleteProviderOrder(order)"></button>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8">No provider orders in this order set.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <button pButton pRipple type="button" label="Create Nursing Order" icon="pi pi-plus"
        (click)="openNursingOrderDialog()"></button>

      <h3>Nursing Orders</h3>
      <div class="table-container">
        <p-table #dt [value]="nursingOrdersForThisOrderSet" styleClass="p-datatable" [rowHover]="true" [rows]="5"
          [showCurrentPageReport]="true" [rowsPerPageOptions]="[5, 10, 25]" responsiveLayout="scroll" [paginator]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} orders" [filterDelay]="0">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="title">
                <div class="flex justify-content-between align-items-center">
                  Title
                  <p-sortIcon field="title"></p-sortIcon>
                </div>
              </th>
              <th pSortableColumn="signature">
                <div class="flex justify-content-between align-items-center">
                  Signature
                  <p-sortIcon field="signature"></p-sortIcon>
                </div>
              </th>
              <th>
                <div class="flex justify-content-between align-items-center">
                  <div class="actions-title-container">Actions</div>
                </div>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-nursingOrder>
            <tr class="p-selectable-row">
              <td>
                {{ nursingOrder.title }}
              </td>
              <td>
                {{ nursingOrder.signature }}
              </td>
              <td class="actions-container">
                <button pButton type="button" class="p-button-primary" icon="pi pi-eye" pTooltip="View nursing order"
                  (click)="viewNursingOrder(nursingOrder)"></button>
                <button pButton type="button" class="p-button-danger" icon="pi pi-trash" pTooltip="Delete nursing order"
                  (click)="deleteNursingOrder(nursingOrder)"></button>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8">No nursing orders in this order set.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

    </div>
  </div>
</form>